// Generated by purs version 0.13.8
"use strict";
var Data_Function = require("../Data.Function/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Semigroup = require("../Data.Semigroup/index.js");
var Data_Show = require("../Data.Show/index.js");
var Formless_Action = require("../Formless.Action/index.js");
var Formless_Retrieve = require("../Formless.Retrieve/index.js");
var Halogen_HTML_Core = require("../Halogen.HTML.Core/index.js");
var Halogen_HTML_Elements = require("../Halogen.HTML.Elements/index.js");
var Halogen_HTML_Events = require("../Halogen.HTML.Events/index.js");
var Halogen_HTML_Properties = require("../Halogen.HTML.Properties/index.js");
var Lunarbox_Component_Utils = require("../Lunarbox.Component.Utils/index.js");
var Lunarbox_Form_Validation = require("../Lunarbox.Form.Validation/index.js");
var submit = function (buttonText) {
    return Halogen_HTML_Elements.div([ Lunarbox_Component_Utils.className("submit__container") ])([ Halogen_HTML_Elements.button([ Lunarbox_Component_Utils.className("submit__form"), Halogen_HTML_Events.onClick(Data_Function["const"](new Data_Maybe.Just(Formless_Action.submit))) ])([ Halogen_HTML_Core.text(buttonText) ]) ]);
};
var customFormField = function (dictIsSymbol) {
    return function (dictNewtype) {
        return function (dictNewtype1) {
            return function (dictCons) {
                return function (dictCons1) {
                    return function (proxy) {
                        return function (form) {
                            return function (content) {
                                return Halogen_HTML_Elements.div([ Lunarbox_Component_Utils.className("form__group") ])([ content, (function () {
                                    var v = Formless_Retrieve.getError(dictIsSymbol)(dictNewtype)()(proxy)(form);
                                    if (v instanceof Data_Maybe.Just) {
                                        return Halogen_HTML_Elements.div([ Lunarbox_Component_Utils.className("form__message--error form__message") ])([ Halogen_HTML_Core.text(Data_Show.show(Lunarbox_Form_Validation.showFormError)(v.value0)) ]);
                                    };
                                    if (v instanceof Data_Maybe.Nothing) {
                                        return Halogen_HTML_Elements.div([ Lunarbox_Component_Utils.className("form__message--no-error form__message") ])([ Halogen_HTML_Core.text("\u2714 Everything good") ]);
                                    };
                                    throw new Error("Failed pattern match at Lunarbox.Form.Field (line 44, column 7 - line 49, column 112): " + [ v.constructor.name ]);
                                })() ]);
                            };
                        };
                    };
                };
            };
        };
    };
};
var input = function (dictIsSymbol) {
    return function (dictNewtype) {
        return function (dictNewtype1) {
            return function (dictCons) {
                return function (dictCons1) {
                    return function (fieldSymbol) {
                        return function (form) {
                            return function (props) {
                                var html = Halogen_HTML_Elements.input(Data_Semigroup.append(Data_Semigroup.semigroupArray)([ Lunarbox_Component_Utils.className("form__field form__field--text"), Halogen_HTML_Properties.value(Formless_Retrieve.getInput(dictIsSymbol)(dictNewtype)()(fieldSymbol)(form)), Halogen_HTML_Events.onValueInput((function () {
                                    var $13 = Formless_Action.setValidate(dictIsSymbol)(dictNewtype1)()(fieldSymbol);
                                    return function ($14) {
                                        return Data_Maybe.Just.create($13($14));
                                    };
                                })()) ])(props));
                                return customFormField(dictIsSymbol)(dictNewtype)(dictNewtype1)()()(fieldSymbol)(form)(html);
                            };
                        };
                    };
                };
            };
        };
    };
};
module.exports = {
    submit: submit,
    customFormField: customFormField,
    input: input
};
